import { createAsyncThunk } from "@reduxjs/toolkit";
import { MemberErasurePreviewResponse } from "../contracts/MemberErasurePreviewResponse";
import { KeptTrainingRecord } from "../models/MemberErasure";
import { toKeptTrainingRecords } from "../mappers/MemberErasureMapper";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import axiosInstance from "../../axiosInstance/axiosInstance";

/**
 * What erasing the member would keep under legal hold (PD-0021), read when the erasure
 * confirmation opens so it can name the training record and its deletion date.
 */
export const fetchErasurePreview = createAsyncThunk<
  KeptTrainingRecord[],
  string,
  { rejectValue: ApiErrorResponse }
>("members/fetchErasurePreview", async (memberId, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get<MemberErasurePreviewResponse>(
      `/members/${memberId}/erasure-preview`
    );
    return toKeptTrainingRecords(response.data);
  } catch (error: unknown) {
    return rejectWithValue(toApiError(error, "Failed to load the erasure preview"));
  }
});
